import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { screenLog } from "../events";
import { useSubscription } from "@/contexts/SubscriptionContext";

export function useAnalyticsScreenView() {
  const location = useLocation();

  const { isLoading, subscription } = useSubscription();
  useEffect(() => {
    async function logScreen() {
        if (isLoading) {
            return;
        }
      await screenLog(
        location.pathname,
        subscription?.isSubscribed || false
      );
    }
    logScreen();
  }, [location]);
}
